// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page":"page_rERZ0","current":"current_GomgI"};